const STATUS_METADATA = {
  1: { label: 'Not Indexed', badgeClass: 'label-outline-primary' },
  2: { label: 'Queued', badgeClass: 'label-outline-warning' },
  3: { label: 'Processing', badgeClass: 'label-outline-info' },
  4: { label: 'Indexed', badgeClass: 'label-outline-success' },
  5: { label: 'Failed', badgeClass: 'label-outline-danger' },
  6: { label: 'Needs Reindex', badgeClass: 'label-outline-warning' },
};

const SOURCE_KIND_LABELS = {
  1: 'Job Document',
  2: 'Proposal Attachment',
  3: 'Job Upload Form Attachment',
  4: 'Proposal Estimator File',
};

const statusOptions = Object.keys(STATUS_METADATA).map((value) => ({
  value,
  label: STATUS_METADATA[value].label,
}));

const sourceKindOptions = Object.keys(SOURCE_KIND_LABELS).map((value) => ({
  value,
  label: SOURCE_KIND_LABELS[value],
}));

const fileTypeOptions = [
  { value: 'pdf', label: 'PDF' },
  { value: 'word', label: 'Word' },
  { value: 'powerpoint', label: 'PowerPoint' },
  { value: 'excel', label: 'Excel' },
  { value: 'image', label: 'Image' },
];

const getStatusMetadata = (value) => STATUS_METADATA[value] || { label: 'Unknown', badgeClass: 'label-light-primary' };

const getSourceKindLabel = (value) => SOURCE_KIND_LABELS[value] || 'Unknown Source';

const EXTRACTION_METHOD_LABELS = {
  doclingmarkdown: 'Docling',
  pdfiumtext: 'PDFium',
  tesseractocr: 'TesseractOCR',
};

const getExtractionMethodLabel = (value) => {
  if (typeof value !== 'string') return value;
  return EXTRACTION_METHOD_LABELS[value.toLowerCase()] || value;
};

const formatDateTime = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) || date.getUTCFullYear() <= 1 ? null : date.toLocaleString([], { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });
};

const formatDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) || date.getUTCFullYear() <= 1
    ? null
    : date.toLocaleDateString([], { year: 'numeric', month: 'numeric', day: 'numeric' });
};

const joinDisplayValues = (...values) => values.filter((value) => value !== null && value !== undefined && value !== '').join(' - ');

const getResourcePreviewType = (contentType, fileName) => {
  const normalizedContentType = (contentType || '').toLowerCase();
  const normalizedFileName = (fileName || '').toLowerCase();
  if (normalizedContentType === 'application/pdf' || normalizedFileName.endsWith('.pdf')) return 'pdf';
  if (normalizedContentType.startsWith('image/') || /\.(png|jpe?g)$/.test(normalizedFileName)) return 'image';
  return 'other';
};

export { fileTypeOptions, formatDate, formatDateTime, getExtractionMethodLabel, getResourcePreviewType, getSourceKindLabel, getStatusMetadata, joinDisplayValues, sourceKindOptions, statusOptions };
